import React from 'react'

const ContactCard = ({icon, title, decription, type = 'text'}) => {
  return (
    <div className="group w-full flex items-center gap-x-4 p-2 rounded-lg shadow-[0_4px_20px_rgba(0,0,0,0.2)]">
      <div className='group-hover:opacity-60 transition-all'>
        {icon}
      </div>
      <div className="grid gap-y-1">
        <h3 className='font-semibold'>{title}</h3>
        {type == 'mobile_number' && <a href="tel:+966500141430" dir="ltr">+966 50 014 1430</a>}
        {type == 'email' &&  <a href={`mailto:${decription}`} >{decription}</a>}
        {type == 'text' &&  <p>{decription}</p>}
        {type == 'address' &&  <address className="inline not-italic">{decription}</address>}
      </div>
    </div>
  )
}

export default ContactCard